import { AttachmentAttributeModel } from '@tailormap-viewer/api';

export interface FeatureInfoAttachmentAttributeMetadata extends AttachmentAttributeModel {
  layerId: string;
}
